import React from 'react'
import { useTranslation } from 'react-i18next';
function Quote() {
    const { t } = useTranslation();
    return(
        <section className="knsl-p-100-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="knsl-quote-with-author">
                            <div className="row align-items-center">
                                <div className="col-lg-4">
                                <div className="knsl-photo-frame">
                                    <img src="assets/img/faces/author.png" alt="Author" />
                                </div>
                                </div>
                                <div className="col-lg-8">
                                <blockquote className="">
                                    {t('main.topManagerSpeech')}
                                </blockquote>
                                <div className="knsl-quote-bottom">
                                    <div>
                                    <h4 className="">Aristide Nomo</h4>
                                    <p>{t('main.topManager')}</p>
                                    </div>
                                    <img src="assets/img/signature.png" alt="signature" className="knsl-signature" />
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
} 

export default Quote as React.FC